export default "__VITE_ASSET__Dt5f3FM3__"